import Arrow, { ARROW_TYPES } from 'components/common/Arrow';

/* Styled Components */
import {
  PageTitle,
  SectionHeaderWrapper,
  SectionHeaderArrowWrapper,
} from 'styles/signup/MultiScreenSignupPage';

type PropsType = {
  title: string;
  onBackClicked: () => void;
};

const SectionHeader = ({ title, onBackClicked }: PropsType) => (
  <SectionHeaderWrapper>
    <SectionHeaderArrowWrapper>
      <Arrow
        arrowType={ARROW_TYPES.POINTED_ARROW_WITH_TAIL}
        onClick={onBackClicked}
        overrideStyle={{ cursor: 'pointer' }}
        width={16}
        height={16}
      />
    </SectionHeaderArrowWrapper>
    <PageTitle center>{title}</PageTitle>
    <div />
  </SectionHeaderWrapper>
);

export default SectionHeader;
